import React, { useEffect, useRef, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import "./navbar.scss";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import './navbar.scss';

const Navbar = () => {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState("");
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <section className='main_navbar'>
        <div className="custom-container">
          <div className='inner_navbar'>
            <img src='\assets\logo.svg' />
            <div className='middle_side'>
              <HashLink to="/#home" className={activeSection === "home" ? "active" : ""}>Home</HashLink>
              <HashLink to="/#problem" className={activeSection === "about" ? "active" : ""}>Problem</HashLink>
              <HashLink to="/#solution" className={activeSection === "overview" ? "active" : ""}>Solution</HashLink>
              <HashLink to="/#portfolio" className={activeSection === "howitswork" ? "active" : ""}>Portfolio</HashLink>
              <HashLink to="/#whywewin" className={activeSection === "benefits" ? "active" : ""}>Why We Win</HashLink>
              <HashLink to="/#whynow" className={activeSection === "benefits" ? "active" : ""}>Why Now</HashLink>
            </div>
          </div>
        </div>

      </section>
      <div className='phone_navbar'>
        <div className='inner_phone'>
          <img src='\assets\logo.svg' />
          <img src='\assets\phonetool.svg' onClick={handleShow} />
        </div>
      </div>
      <Offcanvas show={show} onHide={handleClose} className="navbar">
        <Offcanvas.Header>
          <Offcanvas.Title>
            <div className="navsidebar">
              <Link to="/"><img src="/assets/logo.svg" onClick={handleClose} />
              </Link>

              <img src="\assets\cross.svg" onClick={handleClose} />
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="linkssside">
            <HashLink onClick={handleClose} to="/#home" className={activeSection === "whychooseus" ? "active" : ""}>Home</HashLink>
            <HashLink onClick={handleClose} to="/#problem" className={activeSection === "whychooseus" ? "active" : ""}>Problem</HashLink>
            <HashLink onClick={handleClose} to="/#solution" className={activeSection === "whychooseus" ? "active" : ""}>Solution</HashLink>
            <HashLink onClick={handleClose} to="/#portfolio" className={activeSection === "whychooseus" ? "active" : ""}>Portfolio</HashLink>
            <HashLink onClick={handleClose} to="/#whywewin" className={activeSection === "whychooseus" ? "active" : ""}>Why We Win</HashLink>
               <HashLink onClick={handleClose} to="/#whynow" className={activeSection === "whychooseus" ? "active" : ""}>Why Now</HashLink>

          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

export default Navbar
